import React from 'react';
import PropTypes from 'prop-types';

import './QuestionnaireContent.scss';
import {getQuestionnaireScores, formatQuestionnaireScores} from "../../../../utils/utils";

export default function QuestionnaireContent(props) {
  return (
    <div>
      <p>{props.status === 'completed' && formatQuestionnaireScores(getQuestionnaireScores(props))}</p>
    </div>
  )
}

QuestionnaireContent.propTypes = {
  status: PropTypes.string,
}
